<template>
<div class="chat-page">
  <el-container  class="chat-wrapper" v-loading="isLoading">
    <el-aside width="240px" class="left-aside">
    <!-- 私聊页面 -->
      <MessageBox :type="cPageType" :select="select" ref="messageBox" />
    </el-aside>
    <el-container>
      <Message
        :type="cPageType"
        :hideUserList="hideUserList"
        :showUserList="showUserList"
        :selectMess="selectMess"
        ref="messageList"
      />
    </el-container>
  </el-container>
  <!-- 添加好友 -->
  <AddFriend ref="addFriendMethods" />
  <!-- 好友申请  好友黑名单 加入群组
  <GetFriendRequest />
  <FirendBlack ref="firendModel" />
  <AddGroupUser ref="addGroupModel" /> -->
  <!-- 创建群组 -->
  <!-- <CreateGroup ref="createGroupModel" />   -->
  <!-- <VidoeSetting ref="videoSetting" /> -->
  <!-- <GroupRequest /> -->
  <!-- <GroupInvite /> -->
</div>
</template>

<script>
import MessageBox from "./children/chat/index.vue";
import Message from "./children/chat/message.vue";
import AddFriend from "./children/addModal/addFriend.vue";
// import GetFriendRequest from "./children/addModal/getFriendRequest.vue";
// import FirendBlack from "./children/addModal/firendBlack.vue";
// import AddGroupUser from "./children/group/addGroupUser.vue";
// import CreateGroup from "./children/group/createGroup.vue";
// import VidoeSetting from "./children/videoSetting/index";
// import GroupRequest from "./children/group/groupRequest.vue";
// import GroupInvite from "./children/group/groupInvite.vue";
import { mapState, mapActions } from "vuex";
import {GetManagementImUser,GetUserSingleChats} from '@/service/webImApi.js'
import { getStorage } from '@/utils/util.js'
import { getStorageAdminUser } from '@/utils/store'
export default {
  data() {
    return {
      isLoading: true,
      groupRead: false,
      contactRead: false,
      showSettingOptions: false,
      selectedItem: "",
      showAddOptions: false,
      addList: [
        {
          name: "添加好友",
          id: "1",
          icon: "chat"
        },
        {
          name: "申请入群",
          id: "2",
          icon: "friends"
        },
        {
          name: "创建群组",
          id: "3",
          icon: "comment"
        }
      ],
      collapsed: false,
      current: ["group"],
      groupId:'',
      userCode:'',
      selectMess: {},
      userInfo: getStorageAdminUser(),
      resetElem: true
    }
  },
  computed: {
    chatList() {
      return this.$store.state.chat.msgList;
    },
    hxIsLogin(){
      return this.$store.state.hxIsLogin;
    },
    ...mapState({
      chatId:state=>state.chatId,
      historyChatId:state=>state.historyChatId,
      hxIsLogin:state=>state.hxIsLogin,
      cPageType:state=>state.chat.cPageType,
    })
  },
  watch: {
    historyChatId(value) {
      this.historyChatId = JSON.parse(this.historyChatId) || {contact: '', group: ''}
      localStorage.setItem('historyChatId', this.historyChatId)
    },
    $route: {
      handler: function(to, from) {
        if(to.name == 'chatChatContentGroup') {
        this.$store.commit('setCPageType', 'group')

          console.log("进入群聊页了 ",this.historyChatId['group']);
          this.$store.commit('setChatId', this.historyChatId['group']);
        }else {
          this.$store.commit('setCPageType', 'contact')
          console.log("进入单聊页",this.historyChatId['contact']);
          this.$store.commit('setChatId', this.historyChatId['contact']);
        }
        this.chatTypeChange(this.cPageType)
      },
      immediate: true
    },
    hxIsLogin(value){
      if(value){
        let that=this;
        if (this.cPageType === "contact") {
          this.onGetContactUserList();
        } else if (this.cPageType === "group") {
        this.onGetGroupinfo({select_groupid: this.chatId});
          this.onGetGroupUserList();
        } else if (this.cPageType === "chatroom") {
          this.onGetChatroomUserList();
        }
      }
    },
    chatId(value,old){
      if(value!=old && this.cPageType=='group'){
        this.onGetGroupinfo({
          select_groupid: this.chatId
        })
      }
    },
  },
  created() {
    this.groupId= '';
    this.userCode= '';
    console.log("create \\\\\\\\\\\\\\\\\\\\\\");
    this.$store.commit('setChatType', 'group');
    if(this.groupId){
      this.$store.commit('setChatId', this.groupId);
    }
  },
  mounted() {
    console.log("create \\\\\\\\\\\\\\\\\\\\\\",this.hxIsLogin);
    // if(this.hxIsLogin){
    //   this.getUnread('group');
    //   this.onGetGroupinfo({select_groupid:this.chatId});
    // }
    if(!this.hxIsLogin) {  // 没有登录的话
      this.pageInit();
    }
    this.chatTypeChange(this.cPageType)
    setTimeout(() => {
      this.isLoading = false
    }, 8000);
  },
  methods: {
    ...mapActions([
      "onLogout", 
      "onGetFirendBlack",
      'onLogin',
      "onGetContactUserList",
      "onGetGroupUserList",
      "onGetChatroomUserList",
      'onGetGroupinfo']),
    pageInit(){
      let params={
        platform:'pcweb',
        userId: this.userInfo.role_id
      };
      //获取环信登录名和密码
      GetManagementImUser(params).then(r=>{
        if(r.Result==1){
          this.onLogin({
            username: r.Data.ImUserId,
            password: r.Data.ImUserPassWord
          }).then(res=>{
            GetUserSingleChats({
              PageSize:999,
              PageNo:1,
              UserCode: r.Data.ImUserId.split('-')[1],
              platform:'pcweb'
            }).then(chatRes=>{
                console.log("chatRes ############",chatRes);
                if(chatRes.Result==1){
                    let arr=[];
                    if(r.Data.ImUserId){  
                      arr=arr.concat(chatRes.Data.FriendsLines);
                    }
                    this.$store.commit('setSingleChatList',arr);
                  }
              })
          })
        }
      })
    },
    toLogout() {
      this.onLogout();
    },
    onCollapse(collapsed, type) {
      if (type != "responsive") {
        this.$data.collapsed = true;
      } else {
        this.$data.collapsed = false;
      }
    },
    hideUserList() {
      this.$data.collapsed = true;
    },
    showUserList() {
      this.$data.collapsed = false;
    },
    select(i) {
      console.log("点击了某个用户之后",i);
      this.$refs.messageList.select(i);
      this.selectMess = i;
    },
    GetFirendBlack() {
      this.onGetFirendBlack();
      this.$refs.firendModel.changModel();
    },
    optionsVisibleChange() {
      this.$data.showSettingOptions = !this.$data.showSettingOptions;
    },
    chatTypeChange(type) {
      switch (type) {
        case "contact":
          this.$refs.messageBox.onGetContactUserList();
          break;
        case "group":
          this.$refs.messageBox.onGetGroupUserList();
          break;
        case "chatroom":
          this.$refs.messageBox.onGetChatroomUserList();
          break;
        default:
          break;
      }
      this.$refs.messageList.getCurrentMsg(type);
    },
    addModalChange() {
      this.$data.showAddOptions = !this.$data.showAddOptions;
    },
    ulClick(i) {
      // this.addModalChange();
      switch (i) {
        case "1":
          this.$refs.addFriendMethods.changeModal();
          break;
        case "2":
          this.$refs.addGroupModel.changeGroupModel();
          break;
        case "3":
          this.$refs.createGroupModel.changeCreateModel();
          break;
        default:
          break;
      }
    },
    // recEmedia() {
    //   this.$refs.videoSetting.show();
    // },
    getUnread(type) {
      const chatList = this.chatList[type];
      let obj = {
        contact: false,
        group: false
      };
      if (JSON.stringify(chatList) != "{}") {
        for (const item in chatList) {
          chatList[item].map((v, k) => {
            if (v.status === "unread") {
              if (v.chatType === "group") {
                obj.group = true;
              }
              if (v.chatType === "contact") {
                obj.contact = true;
              }
            }
            return obj;
          });
        }
      }
      return {
        contact: obj.contact,
        group: obj.group
      };
    }
  },
  components: {
    MessageBox,
    Message,
    AddFriend,
    // GetFriendRequest,
    // FirendBlack,
    // AddGroupUser,
    // CreateGroup,
    // VidoeSetting,
    // GroupRequest,
    // GroupInvite
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/reset.scss';
body{
  background-color: rgba(0,0,0,0.6) !important;
}
.left-aside{
  background-color: #fff;
}
.chat-wrapper{
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  height: 800px;
  overflow: auto;
}
</style>
